import React, { useEffect } from 'react';
import Page from '../components/Page';
import { track } from '../analytics';

// Each review is an array of paragraphs. `name` is optional.
const reviews = [
  {
    id: 1,
    text: [
      `I personally found Mr. Capildeo's maths lessons to be a wonderful experience. His classes were extremely helpful to me because I entered expecting to achieve a Grade 4 or 5 in CSEC Mathematics, but thanks to his excellent teaching, I now feel confident that I can achieve a Grade 1 or 2.`,
      `I would definitely recommend Mr. Capildeo's classes to all students. He is very patient and always asks if we need additional help without ever making us feel ashamed to ask questions. Mr. Capildeo is also very funny and keeps the classes enjoyable with his jokes, even though he cannot hear us "NPCs" laughing because our microphones are off.`,
      `Overall, his teaching style makes learning maths much easier, more comfortable, and enjoyable.`,
    ],
  },
  {
    id: 2,
    text: [
      `Mr Gopeesingh's Unit 2 Pure Mathematics sprint class offered a complete coverage and practice for the subject syllabus, accomplishing more work in 1 month than most could do in an entire year.`,
      `He explained each topic with ease and extreme expertise, offering a more than happy willingness to repeat any topics with me that I didn't fully internalize.`,
      `Mr. Gopeesingh's attitude and work ethic quickly spread to us, his students, encouraging us to have an engaging class where we were confident in asking questions of any kind.`,
    ],
  },
  {
    id: 3,
    text: [
      `Thank you soo much for being one of the greatest teachers ever! In this past month I've learnt soo much and was able to grasp concepts I couldn't for the entire year. The class was interactive and fun, the notes were awesome and really, it couldn't have been better!! I'd recommend everyone to this class.`,
    ],
  },
  {
    id: 4,
    text: [
      `I really appreciated your lessons and how patient you were with all of us. You always made sure everyone understood before moving on, and that honestly helped a lot. I liked that you took the time to explain things properly and made maths feel less confusing or stressful.`,
    ],
  },
  {
    id: 5,
    text: [
      `I highly recommend Mr. Capildeo, as the clear explanations and excellent exam preparation helped me tremendously with my CSEC journey for maths.`,
    ],
  },
  {
    id: 6,
    text: [
      `Thank you for the opportunity for being part of your classes Sir, and being allowed the opportunity to ask a lot of questions and getting them answered.`,
    ],
  },
];

const Reviews = () => {
  useEffect(() => track('ViewContent', { custom: { content_name: 'Reviews' } }), []);

  return (
    <Page title="Reviews from past students">
      <div className="flex flex-col gap-6">
        {reviews.map(({ id, name, text }) => (
          <blockquote
            key={id}
            className="rounded-lg border border-navy/15 bg-white p-8 shadow-sm"
          >
            <div className="flex flex-col gap-3 leading-relaxed text-gray-700">
              {text.map((paragraph, i) => (
                <p key={i}>
                  {i === 0 && <span className="text-navy">&ldquo;</span>}
                  {paragraph}
                  {i === text.length - 1 && <span className="text-navy">&rdquo;</span>}
                </p>
              ))}
            </div>
            {name && <footer className="mt-4 font-semibold text-navy">{name}</footer>}
          </blockquote>
        ))}
      </div>
    </Page>
  );
};

export default Reviews;
